module.exports = __webpack_public_path__ + "img/ticket-figma.230fb6be.png";